import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import Box from "@mui/material/Box";
import { CircularProgress } from "@material-ui/core";
import { setLicense } from "../redux/slices/licenseSlice";
import { styled } from '@mui/material/styles';
import theme from "../theme";


import { setLogout } from "../redux/slices/authSlice";
import { setLogoutUser } from "../redux/slices/userSlice";

import { setLogoutLocation } from "../redux/slices/locationSlice";
import { setLogoutMeetingSpaces } from "../redux/slices/allMeetingSpacesSlice";
import { setEmmsHeaders } from "../redux/slices/emmsAuthSlice";
import { setLogoutCurrentEmms } from "../redux/slices/currentEmmsSlice";
import { setLogoutCustomisation } from "../redux/slices/customisationSlice";
import { setLogoutScreenuser } from "../redux/slices/screenusersSlice";

import { toast } from "react-toastify";


import { ThemeProvider, createTheme } from "@mui/material/styles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  maxWidth: 450,
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  paddingTop: 2,
  paddingBottom: 2,
  paddingLeft: 3,
  paddingRight: 3,
};

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#19433E"),
  backgroundColor: "#19433E",
  "&:hover": {
    backgroundColor: "#2b3842",
  },
}));


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "34ch",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "10px"
  },
  label: {
    fontWeight: "bold"
  },

}));

const MyLicenseForm = () => {
  const classes = useStyles();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const headers = useSelector((state) => state.header);
  const [formData, setFormData] = useState({
    licensekey: "",
  });
  const api = localStorage.getItem("api");
  const [error, setError] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const oldData = useSelector((state) => state.license);

  const dispatch = useDispatch();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };
  const handlesignoutWithDelay = () => {
    setTimeout(() => {
      handlesignout();
    }, 5000);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    if (oldData.license == null) {
      axios
        .post(api + `/license`, { ...formData }, { headers: headers.token })
        .then((response) => {

          if (response.status == 200) {
            setErrorModalOpen(true);
            setErrorMessage(`License created successfully`);
            setFormData({
              licensekey: "",
            });
            try {
              const combinedData = [...oldData.license, response.data];
              dispatch(setLicense(combinedData));
            } catch (error) {
              console.log(error);
            }
            setError(false);
            handlesignoutWithDelay();
          }
          setIsSubmitting(false);
        })
        .catch((error) => {
          setErrorModalOpen(true);
          setErrorMessage(`Error creating license: ${error.response.data}`);
          setFormData({
            licensekey: "",
          });
          setError(true);
        });
    } else {
      setOpen(false);
      setIsSubmitting(false);
      toast.error("License already exists", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  const handleModalClose = () => {
    setErrorModalOpen(false);
    setErrorMessage("");
    setOpen(false);
    setIsSubmitting(false);
  };
  const handlesignout = () => {
    dispatch(setLogoutUser());
    dispatch(setLogout());
    dispatch(setLogoutCurrentEmms());
    dispatch(setLogoutLocation());
    dispatch(setLogoutCustomisation());
    dispatch(setLogoutMeetingSpaces());
    dispatch(setLogoutScreenuser());
    dispatch(setEmmsHeaders());
  };
  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };
  return (


    <div>
      <ThemeProvider theme={theme}>
        <ColorButton
          className={classes.button}
          variant="contained"
          color="primary"
          onClick={handleOpen}
          style={{ textTransform: "none" }}
        >
          Add License
        </ColorButton>

        <Modal open={open} onClose={handleClose}>
          <Box sx={style}>
            <div>
              <h2>License </h2>
              <h4 style={{ fontWeight: "100" }}>Add license for Landscape Manager </h4>
            </div>
            <form
              className={classes.root}
              noValidate
              autoComplete="off"
              onSubmit={handleSubmit}
            >
              <div style={{ display: "flex" }}>
                {getLabelWithAsterisk("LicenseKey:", true)}
                <TextField
                  required
                  id="licensekey"
                  label="License for ELM"
                  name="licensekey"

                  variant="outlined"
                  multiline
                  rows={3}
                  value={formData.licensekey}
                  onChange={handleChange}
                />
              </div>

              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  mt:2,
                  justifyContent:"end"
                }}
              >
                <Button
                  style={{ textTransform: "none" }}
                  variant="outlined"
                  color="primary"
                  onClick={() => setOpen(false)}
                  disabled={isSubmitting}
                >
                  Close
                </Button>
                <ColorButton
                  style={{ textTransform: "none" }}
                  type="submit"
                  variant="contained"

                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <CircularProgress size={24} /> : "Submit"}
                </ColorButton>

              </Box>

              <Modal
                open={errorModalOpen}
                onClose={handleModalClose}
                className={classes.modal}
              >
                <div className={classes.paper}>
                  <h2>{error === true ? "Oops" : "Congratulations"}</h2>
                  <p>{errorMessage}</p>
                  <ColorButton style={{ textTransform: "none", marginLeft: "75%" }}
                    onClick={handleModalClose}
                    variant="contained"
                    color="primary"
                  >
                    Close
                  </ColorButton>
                </div>
              </Modal>
            </form>
          </Box>
        </Modal>
      </ThemeProvider>

    </div>

  );
};

export default MyLicenseForm;
